import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { LoadNoteType } from './load-note-type.model';
import { map } from 'rxjs/operators';

@Injectable()
export class LoadNoteTypeService {

  private LOAD_NOTE_TYPE_URI = 'loads/notes/types';

  constructor(private http: HttpClient) {
  }

  public getWritablesForSelfCarrier(): Observable<LoadNoteType[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_NOTE_TYPE_URI}/writables`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(e => LoadNoteType.fromDto(e)))
      );
  }

  public getWritablesForCarrier(carrier: Carrier): Observable<LoadNoteType[]> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.LOAD_NOTE_TYPE_URI}/${carrier.id}/writables`;

    return this.http.get(url, { headers })
      .pipe(
        map((result: any[]) => result.map(e => LoadNoteType.fromDto(e)))
      );
  }

}
